import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface Supervisor {
  id?: number;
  username: string;
  name: string;
  cpf: string;
  phone: string;
  email: string;
  active: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface SupervisorApi {
  id?: number;
  username: string;
  nome: string;
  cpf: string;
  telefone: string;
  email: string;
  ativo: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateSupervisor {
  username: string;
  password: string;
  name: string;
  cpf: string;
  phone: string;
  email: string;
  active: boolean;
}

export interface CreateSupervisorReqRes {
  id?: number;
  usuarioId?: number;
  username: string;
  senha: string;
  nome: string;
  cpf: string;
  telefone: string;
  email: string;
  ativo: boolean;
}

export interface UpdateSupervisorRequest {
  username?: string;
  password?: string;
  name?: string;
  cpf?: string;
  phone?: string;
  email?: string;
  active?: boolean;
}

export interface PaginatedSupervisorsResponse {
  content: Supervisor[];
  totalElements: number;
  totalPages: number;
  number: number;
  size: number;
}

@Injectable({
  providedIn: 'root',
})
export class SupervisorService {
  private apiUrl = `${environment.apiUrl}/admin/fiscais`;

  constructor(private http: HttpClient) {}

  /**
   * Get all supervisors with optional pagination and search
   * @param params - Optional parameters for filtering and pagination
   * @returns Observable with paginated supervisors
   */
  getSupervisors(params?: {
    page?: number;
    size?: number;
    name?: string;
  }): Observable<PaginatedSupervisorsResponse> {
    let httpParams = new HttpParams();

    if (params?.page !== undefined) {
      httpParams = httpParams.set('page', params.page.toString());
    }
    if (params?.size !== undefined) {
      httpParams = httpParams.set('size', params.size.toString());
    }
    if (params?.name) {
      httpParams = httpParams.set('nome', params.name);
    }

    return this.http.get<PaginatedSupervisorsResponse>(this.apiUrl, {
      params: httpParams,
    });
  }

  /**
   * Get supervisor by ID
   */
  getSupervisorById(id: number): Observable<Supervisor> {
    return this.http.get<Supervisor>(`${this.apiUrl}/${id}`);
  }

  /**
   * Create new supervisor
   */
  createSupervisor(supervisor: CreateSupervisorReqRes): Observable<Supervisor> {
    return this.http.post<Supervisor>(this.apiUrl, supervisor);
  }

  /**
   * Update existing supervisor
   */
  updateSupervisor(
    id: number,
    supervisor: UpdateSupervisorRequest
  ): Observable<Supervisor> {
    return this.http.put<Supervisor>(`${this.apiUrl}/${id}`, supervisor);
  }

  /**
   * Delete supervisor
   */
  deleteSupervisor(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  /**
   * Toggle supervisor active status
   */
  toggleSupervisorStatus(id: number, active: boolean): Observable<Supervisor> {
    let httpParams = new HttpParams();

    httpParams = httpParams.set('ativo', active.toString());
    return this.http.patch<Supervisor>(`${this.apiUrl}/${id}/status`, null, {
      params: httpParams,
    });
  }
}
